import { HtmlButtonElement } from "./HtmlButtonElement";
import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "./HtmlContainerElement";
import { HtmlController } from "../HtmlController";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlCheckboxElement extends HtmlButtonElement {
    private checkbox: HTMLInputElement = null;

    constructor() {
        super();
    }

    create(node: Element): void {
        super.create(node);
        this.createCheckBox();
    }

    private createCheckBox(): void {
        this.checkbox = <HTMLInputElement>document.createElement("input");
        this.checkbox.type = "checkbox";
        this.checkbox.classList.add("checkbox");
        this.checkbox.addEventListener("input", this.onCheckbox.bind(this));

        if (this.instance != null) {
            this.instance.appendChild(this.checkbox);
        }

        this.instance.classList.add("checkboxButton");
    }

    onClick(): void {
        //remove implementation and move it to onCheckBox
    }

    onCheckbox(): void {
        if (DEBUG) {
            this.log("onClick action: " + this.action + " uiaction: " + this.uiaction);
        }

        if (this.instance != null && !this.instance.classList.contains(HtmlController.DisabledClass)) {
            if (this.action != null) {
                HtmlController.dispatchAction(this.action);
            }

            if (this.uiaction != null) {
                for (var i: number = 0; i < this.uiaction.length; i++) {
                    HtmlController.dispatchUiAction(this.uiaction[i]);
                }
            }
        }
    }

    setText(value?: string): void {
        if (value === undefined || value === null) {
            this.checkbox.checked = !this.checkbox.checked;
            return;
        }
        if (value == "true") {
            if (this.checkbox.checked) {
                return;
            }
            this.checkbox.checked = true;
        } else {
            if (!this.checkbox.checked) {
                return;
            }
            this.checkbox.checked = false;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlCheckboxElement.ts
 **/